import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

export const authAPI = {
  signup: (data) => api.post('/auth/signup', data),
  login: (data) => api.post('/auth/login', data)
};

export const predictionAPI = {
  predict: (data) => api.post('/predict', data),
  addSleepData: (data) => api.post('/sleep-data', data)
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getCharts: () => api.get('/dashboard/charts'),
  getHistory: () => api.get('/history'),
  getInsights: () => api.get('/insights')
};

export default api;
